// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const NetworkDevicesIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 38 27">
    <path
      fill="url(#network-devices_svga)"
      d="M.67 8 4 11.33a21.2 21.2 0 0 1 30 0L37.33 8A25.94 25.94 0 0 0 .67 8M14 21.33l5 5 5-5a7.06 7.06 0 0 0-10 0m-6.67-6.66L10.67 18c4.6-4.6 12.06-4.6 16.66 0l3.34-3.33a16.5 16.5 0 0 0-23.34 0"
    />
    <defs>
      <linearGradient
        id="network-devices_svga"
        x1={0.67}
        x2={26.14}
        y1={0.41}
        y2={34.66}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E45E2" />
        <stop offset={1} stopColor="#A22E95" />
      </linearGradient>
    </defs>
  </svg>,
  "NetworkDevices",
);
export default NetworkDevicesIcon;
